import { getAnalytics, isSupported, logEvent, type Analytics } from "firebase/analytics";
import { firebaseApp } from "./firebase-app";

let analytics: Analytics | null = null;
let readyPromise: Promise<void> | null = null;

/**
 * Initializes Firebase Analytics (GA4) once. Safe to call multiple times or
 * where unsupported (no measurementId, SSR, private browsing blocking
 * storage) — trackEvent() is then simply a no-op instead of throwing.
 */
export function initAnalytics(): void {
  if (readyPromise) return;
  readyPromise = (async () => {
    if (!import.meta.env.VITE_FIREBASE_MEASUREMENT_ID) return;
    try {
      if (!(await isSupported())) return;
      analytics = getAnalytics(firebaseApp());
    } catch {
      // Blocked (ad blocker, private mode, unsupported browser) — no-op.
    }
  })();
}

/** Fire a GA4 custom event. No-ops silently if analytics isn't available. */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!analytics) return;
  try {
    logEvent(analytics, name, params);
  } catch {
    // Never let analytics break the app.
  }
}
